// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"list_group_list_modalWrap__UeFWQ","modalButtons":"list_group_list_modalButtons__1ulA3","modalButton":"list_group_list_modalButton__1B_HD"};